export const recentlyImpersonatedClientsSelector = state => state.ui.impersonation.recentlyImpersonatedClientIds;
